import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { apiError } from '../config/axios';
import { FaUser, FaLock } from 'react-icons/fa';
import PasswordInput from '../components/PasswordInput';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);

  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('sessionExpired')) {
      setSessionExpired(true);
      localStorage.removeItem('sessionExpired');
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) navigate('/canciones', { replace: true });
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);
    try {
      await login({ email, password });
      navigate('/canciones');
    } catch (err) {
      setError(apiError(err, 'Error al iniciar sesión'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center"
         style={{ background: 'linear-gradient(160deg, #eef2ff 0%, #f8fafc 100%)' }}>
      <div className="card shadow" style={{ maxWidth: '26rem', width: '100%' }}>
        <div className="card-body p-4">
          <div className="text-center mb-3">
            <img src="/logo.svg" alt="" width={64} height={64} />
            <h1 className="h3 fw-bold mt-2 mb-0 text-brand">Mi Ensamble</h1>
            <p className="text-muted mb-0">Cancionero de tu grupo</p>
          </div>

          {error && <div className="alert alert-danger" role="alert">{error}</div>}
          {sessionExpired && (
            <div className="alert alert-warning" role="alert">
              Tu sesión expiró. Vuelve a iniciar sesión.
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label fw-semibold">
                <FaUser className="me-2" aria-hidden />Correo electrónico
              </label>
              <input
                type="email" id="email" className="form-control form-control-lg"
                value={email} onChange={(e) => setEmail(e.target.value)}
                required autoComplete="email" disabled={isLoading}
              />
            </div>

            <div className="mb-4">
              <label htmlFor="password" className="form-label fw-semibold">
                <FaLock className="me-2" aria-hidden />Contraseña
              </label>
              <PasswordInput
                id="password"
                className="form-control form-control-lg"
                value={password}
                onChange={setPassword}
                required
                disabled={isLoading}
              />
            </div>

            <button type="submit" className="btn btn-primary btn-lg w-100" disabled={isLoading}>
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden />
                  Iniciando sesión…
                </>
              ) : 'Iniciar sesión'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
